export enum CalendarsLimitType {
  unlimited = 'unlimited',
  primary = 'primary',
  default = 'default',
}
